import React, { useState, useEffect } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Chip,
  CircularProgress,
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Layout from '../components/Layout/Layout';
import apiService from '../services/api';

const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 300,
  },
  profit: {
    color: '#2e7d32',
    fontWeight: 600,
  },
  loss: {
    color: '#c62828',
    fontWeight: 600,
  },
}));

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#1a1a2e',
    color: '#fff',
    fontWeight: 600,
  },
}))(TableCell);

function Performance() {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [trades, setTrades] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const data = await apiService.getCatalogTrades();
      setTrades(data);
    } catch (error) {
      console.error('Error fetching performance:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    return new Date(dateStr).toLocaleDateString('en-IN');
  };

  if (loading) {
    return (
      <Layout title="Performance" onRefresh={fetchData}>
        <Box className={classes.loadingContainer}>
          <CircularProgress />
        </Box>
      </Layout>
    );
  }

  return (
    <Layout title="Performance" onRefresh={fetchData}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Date</StyledTableCell>
              <StyledTableCell>Catalog</StyledTableCell>
              <StyledTableCell>Current Profit</StyledTableCell>
              <StyledTableCell>Target Profit</StyledTableCell>
              <StyledTableCell>Lots Modifier</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {trades.map((trade) => (
              <TableRow key={trade.id} hover>
                <TableCell>{formatDate(trade.created_at)}</TableCell>
                <TableCell>{trade.catalog_name}</TableCell>
                <TableCell className={trade.current_profit >= 0 ? classes.profit : classes.loss}>
                  {trade.current_profit >= 0 ? '+' : ''}{trade.current_profit}
                </TableCell>
                <TableCell>{trade.target_profit}</TableCell>
                <TableCell>{trade.lots_modifier}</TableCell>
                <TableCell>
                  <Chip size="small" label={trade.status || 'N/A'} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Layout>
  );
}

export default Performance;
